/* eslint-disable object-curly-newline */
export const categories = [
  { id: 0, name: "Ver todo", description: "" },
  {
    id: 'Etiquetas',
    name: "Etiquetas",
    description:
      "En poliéster, algodón, bambú, lino y poliéster reciclado. Todas nuestras etiquetas son tejidas para luego pasar por procesos de estampado, sublimado, bordado, laminado, tranfer, quemado, troquelado, doblado, cortado y laser pudiendo combinar diferentes técnicas para llegar al producto que identifique fielmente su marca.",
  },
  { id: 'Escudos y Parches', name: "Escudos y Parches", description: "" },
  {
    id: 'Cintas',
    name: "Cintas",
    description:
      "Al igual que nuestras etiquetas contamos con una gran variedad de materiales y técnicas que combinadas logran productos maravillosos. Nuestros hilos cumplen con la certificación anual OEKOTEX Standart 100. ",
  },
  {
    id: 'Cordones',
    name: "Cordones",
    description:
      "Venimos fabricando cordones y pasadores por más de 100 años. Totalmente personalizables tanto en su cuerpo como en las punteras.",
  },
  {
    id: 'Hangtags y Sigilos',
    name: "Hangtags y Sigilos",
    description:
      "Contamos con productos únicos y totalmente personalizables utilizando combinaciones del papel con tejidos, plástico, metal, cintas y cordones. ",
  },
  {
    id: 'Cueros y Badanas',
    name: "Cueros y Badanas",
    description:
      "Ofrecemos los mejores diseños y acabados en cuero real, cuerina a partir de poliuretano, zetex en base a cartón y combinamos estos materiales con laminados, metal y trabajo en 3D PU. ",
  },
  { id: 'Transfer y Adhesivos', name: "Transfer y Adhesivos", description: "" },
  {
    id: 'Broches y Metales',
    name: "Broches y Metales",
    description:
      "Contamos con todo tipo de accesorios metálicos y 50 baños distintos para lograr el acabado perfecto; nuestros metales y baños siempre libres de metales pesados.",
  },
  { id: 'Sigilos de Seguridad', name: "Sigilos de Seguridad", description: "" },
];

export const materials = [
  {
    cat: 'Group 1',
    key: 'Poliester',
  },
  {
    cat: 'Group 1',
    key: 'Poliester Brillante',
  },
  {
    cat: 'Group 1',
    key: 'Poliuretano',
  },
  {
    cat: 'Group 2',
    key: 'Algodón',
  },
  {
    cat: 'Group 2',
    key: 'Metal',
  },
  {
    cat: 'Group 2',
    key: 'Acetato',
  },
  {
    cat: 'Group 2',
    key: 'Goma',
  },
  {
    cat: 'Group 2',
    key: 'Corte',
  },
  {
    cat: 'Group 2',
    key: 'Enrollado',
  },
  {
    cat: 'Group 2',
    key: 'Estampado',
  },
  {
    cat: 'Group 2',
    key: 'Cartón',
  },
  {
    cat: 'Group 2',
    key: 'Zetex',
  },
  {
    cat: 'Group 2',
    key: 'Vinilo',
  },
  {
    cat: 'Group 2',
    key: 'Resina',
  },
  {
    cat: 'Group 2',
    key: 'Vidrio Micropulverizado',
  },
  {
    cat: 'Group 2',
    key: 'PVC',
  },
  {
    cat: 'Group 2',
    key: 'Lona',
  },
  {
    cat: 'Group 2',
    key: 'Elastano',
  },
];
export const techniques = [
  {
    cat: 'Group 1',
    key: 'Tejido',
  },
  {
    cat: 'Group 1',
    key: 'Corte',
  },
  {
    cat: 'Group 1',
    key: 'Doblez',
  },
  {
    cat: 'Group 2',
    key: 'Termoadhesivo',
  },
  {
    cat: 'Group 2',
    key: 'Corte Laser',
  },
  {
    cat: 'Group 2',
    key: 'Prensado',
  },
  {
    cat: 'Group 2',
    key: 'Estampado',
  },
  {
    cat: 'Group 2',
    key: 'Doblez 90°',
  },
  {
    cat: 'Group 2',
    key: 'Colocacion de Punteras',
  },
  {
    cat: 'Group 2',
    key: 'Enrollado',
  },
  {
    cat: 'Group 2',
    key: 'Baño de Goma',
  },
  {
    cat: 'Group 2',
    key: 'Sin nombre',
  },
  {
    cat: 'Group 2',
    key: 'Impresión',
  },
  {
    cat: 'Group 2',
    key: 'Troquelado',
  },
  {
    cat: 'Group 2',
    key: 'Grabado Laser',
  },
  {
    cat: 'Group 2',
    key: 'Inyeccion de Resina',
  },
  {
    cat: 'Group 2',
    key: 'Quemado',
  },
  {
    cat: 'Group 2',
    key: 'Inyeccion',
  },
  {
    cat: 'Group 2',
    key: 'Maquinado',
  },
];
export const moqs = [
  {
    cat: 'Group 1',
    key: '500',
  },
  {
    cat: 'Group 1',
    key: '1000',
  },
  {
    cat: 'Group 1',
    key: '5000',
  },
];
export const times = [
  {
    cat: 'Group 1',
    key: '30',
  },
  {
    cat: 'Group 1',
    key: '40',
  },
  {
    cat: 'Group 1',
    key: '60',
  },
];
export const brands = [
  {
    cat: 'Group 1',
    key: 'Alianza Lima',
  },
  {
    cat: 'Group 1',
    key: 'BRONCO',
  },
  {
    cat: 'Group 1',
    key: 'Byrsa',
  },
  {
    cat: 'Group 1',
    key: 'CC Manucci',
  },
  {
    cat: 'Group 1',
    key: 'Chester & Peck',
  },
  {
    cat: 'Group 1',
    key: 'CUAP',
  },
  {
    cat: 'Group 1',
    key: 'Donatella',
  },
  {
    cat: 'Group 1',
    key: 'Fortunata & Benito',
  },
  {
    cat: 'Group 1',
    key: 'Generico',
  },
  {
    cat: 'Group 1',
    key: 'GINEBRA',
  },
  {
    cat: 'Group 1',
    key: 'GLENDA BAILEY & PC',
  },
  {
    cat: 'Group 1',
    key: 'KMH',
  },
  {
    cat: 'Group 1',
    key: 'Liberdade',
  },
  {
    cat: 'Group 1',
    key: 'Lilla|P',
  },
  {
    cat: 'Group 1',
    key: 'MARA intimates',
  },
  {
    cat: 'Group 1',
    key: 'Mashmelo',
  },
  {
    cat: 'Group 1',
    key: 'MASP',
  },
  {
    cat: 'Group 1',
    key: 'NORTON',
  },
  {
    cat: 'Group 1',
    key: 'Ñao Existe',
  },
  {
    cat: 'Group 1',
    key: 'Parni Design',
  },
  {
    cat: 'Group 1',
    key: 'PCDA',
  },
  {
    cat: 'Group 1',
    key: 'Peruvian Connection',
  },
  {
    cat: 'Group 1',
    key: 'RAPSODIA',
  },
  {
    cat: 'Group 1',
    key: 'Sport Huancayo',
  },
  {
    cat: 'Group 1',
    key: 'Sushi',
  },
  {
    cat: 'Group 1',
    key: 'UOMO',
  },
];
// export const materials = [
//   { id: 1, name: "Poliester" },
//   { id: 2, name: "Poliester Brillante" },
//   { id: 3, name: "Poliuretano" },
//   { id: 4, name: "Algodón" },
//   { id: 5, name: "Metal" },
//   { id: 6, name: "Acetato" },
//   { id: 7, name: "Goma" },
//   { id: 8, name: "Corte" },
//   { id: 9, name: "Enrollado" },
//   { id: 10, name: "Estampado" },
//   { id: 11, name: "Cartón" },
//   { id: 12, name: "Zetex" },
//   { id: 13, name: "Vinilo" },
//   { id: 14, name: "Resina" },
//   { id: 15, name: "Vidrio Micropulverizado" },
//   { id: 16, name: "PVC" },
//   { id: 17, name: "Lona" },
// ];

export const products = [

  {
    name: "Escudo CUAP",
    id: 100558735,
    product: "Escudo 100% Tejido Termoadhesivo",
    provider: "HACO",
    category: "Escudos y Parches",
    materials: [materials[0].key],
    techniques: [techniques[0].key, techniques[3].key, techniques[4].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: true,
    minPrice: "100",
    maxPrice: "499",
    price: "",
    timeDelivery: "40",
    book: "Portafolio IMX",
    brand: "CUAP",
    img: "https://imx-imagenes.s3.amazonaws.com/0100558735.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0100558735.jpg",
  },
  {
    name: "Escudo Alianza Lima",
    id: 100602977,
    product: "Escudo 100% Tejido Termoadhesivo",
    provider: "HACO",
    category: "Escudos y Parches",
    materials: [materials[0].key],
    techniques: [techniques[0].key, techniques[3].key, techniques[4].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: true,
    minPrice: "100",
    maxPrice: "499",
    price: "",
    timeDelivery: "40",
    book: "Portafolio IMX",
    brand: "Alianza Lima",
    img: "https://imx-imagenes.s3.amazonaws.com/0100602977.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0100602977.jpg",
  },
  {
    name: "Escudo Huancayo",
    id: 100603388,
    product: "Escudo 100% Tejido Termoadhesivo",
    provider: "HACO",
    category: "Escudos y Parches",
    materials: [materials[0].key],
    techniques: [techniques[0].key, techniques[3].key, techniques[4].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: true,
    minPrice: "100",
    maxPrice: "499",
    price: "",
    timeDelivery: "40",
    book: "Portafolio IMX",
    brand: "Sport Huancayo",
    img: "https://imx-imagenes.s3.amazonaws.com/0100603388.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0100603388.jpg",
  },
  {
    name: "Escudo CC Mannucci",
    id: 100603659,
    product: "Escudo 100% Tejido Termoadhesivo",
    provider: "HACO",
    category: "Escudos y Parches",
    materials: [materials[0].key],
    techniques: [techniques[0].key, techniques[3].key, techniques[4].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: true,
    minPrice: "100",
    maxPrice: "499",
    price: "",
    timeDelivery: "40",
    book: "Portafolio IMX",
    brand: "CC Manucci",
    img: "https://imx-imagenes.s3.amazonaws.com/0100603659.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0100603659.jpg",
  },
  {
    name: "Escudo NORTON",
    id: 100617953,
    product: "Escudo Tejido + Estampado + 3D PU",
    provider: "HACO",
    category: "Escudos y Parches",
    materials: [materials[0].key, materials[2].key],
    techniques: [techniques[0].key, techniques[6].key, techniques[3].key, techniques[4].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: true,
    minPrice: "1000",
    maxPrice: "1999",
    price: "",
    timeDelivery: "60",
    book: "Portafolio IMX",
    brand: "NORTON",
    img: "https://imx-imagenes.s3.amazonaws.com/0100617953.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0100617953.jpg",
  },
  {
    name: "Etiqueta de Marca Lilla|P",
    id: 100487893,
    product: "Etiqueta Tejida",
    provider: "HACO",
    category: "Etiquetas",
    materials: [materials[0].key],
    techniques: [techniques[0].key, techniques[1].key, techniques[2].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: true,
    minPrice: "10",
    maxPrice: "49",
    price: "",
    timeDelivery: "40",
    book: "Portafolio IMX",
    brand: "Lilla|P",
    img: "https://imx-imagenes.s3.amazonaws.com/0100487893.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0100487893.jpg",
  },
  {
    name: "Etiqueta de Talla Lilla|P",
    id: 100487894,
    product: "Etiqueta Tejida",
    provider: "HACO",
    category: "Etiquetas",
    materials: [materials[0].key],
    techniques: [techniques[0].key, techniques[1].key, techniques[2].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: true,
    minPrice: "10",
    maxPrice: "49",
    price: "",
    timeDelivery: "40",
    book: "Portafolio IMX",
    brand: "Lilla|P",
    img: "https://imx-imagenes.s3.amazonaws.com/0100487894.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0100487894.jpg",
  },
  {
    name: "Etiqueta UOMO",
    id: 100489864,
    product: "Etiqueta Tejida",
    provider: "HACO",
    category: "Etiquetas",
    materials: [materials[0].key],
    techniques: [techniques[0].key, techniques[1].key, techniques[2].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "10",
    maxPrice: "49",
    price: "",
    timeDelivery: "40",
    book: "Portafolio IMX",
    brand: "UOMO",
    img: "https://imx-imagenes.s3.amazonaws.com/0100489864.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0100489864.jpg",
  },
  {
    name: "Etiqueta Donatella",
    id: 100506287,
    product: "Etiqueta Tejida",
    provider: "HACO",
    category: "Etiquetas",
    materials: [materials[0].key],
    techniques: [techniques[0].key, techniques[1].key, techniques[2].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "10",
    maxPrice: "49",
    price: "",
    timeDelivery: "40",
    book: "Portafolio IMX",
    brand: "Donatella",
    img: "https://imx-imagenes.s3.amazonaws.com/F2DC30DA-16AD-4412-9C13-5B1C29040B57.JPG",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/F2DC30DA-16AD-4412-9C13-5B1C29040B57+mini.jpg",
  },
  {
    name: "Etiqueta BRONCO_1",
    id: 100568965,
    product: "Etiqueta Tejida",
    provider: "HACO",
    category: "Etiquetas",
    materials: [materials[0].key],
    techniques: [techniques[0].key, techniques[1].key, techniques[2].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "10",
    maxPrice: "49",
    price: "",
    timeDelivery: "40",
    book: "Portafolio IMX",
    brand: "BRONCO",
    img: "https://imx-imagenes.s3.amazonaws.com/4168BC11-E32E-4D9F-900C-5527F5A7B449.JPG",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/4168BC11-E32E-4D9F-900C-5527F5A7B449+mini.jpg",
  },
  {
    name: "Etiqueta BRONCO_2",
    id: 100568973,
    product: "Etiqueta Tejida",
    provider: "HACO",
    category: "Etiquetas",
    materials: [materials[0].key],
    techniques: [techniques[0].key, techniques[1].key, techniques[2].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "10",
    maxPrice: "49",
    price: "",
    timeDelivery: "40",
    book: "Portafolio IMX",
    brand: "BRONCO",
    img: "https://imx-imagenes.s3.amazonaws.com/1D5A8895-6A5D-4F17-9D0C-158709C01D26.JPG",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/1D5A8895-6A5D-4F17-9D0C-158709C01D26+mini.jpg",
  },
  {
    name: "Etiqueta BRONCO_3",
    id: 100569608,
    product: "Etiqueta Tejida",
    provider: "HACO",
    category: "Etiquetas",
    materials: [materials[0].key],
    techniques: [techniques[0].key, techniques[1].key, techniques[2].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "10",
    maxPrice: "49",
    price: "",
    timeDelivery: "40",
    book: "Portafolio IMX",
    brand: "BRONCO",
    img: "https://imx-imagenes.s3.amazonaws.com/7E55C636-409C-4B1C-B7EF-BA8E4FFF3DA5.JPG",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/7E55C636-409C-4B1C-B7EF-BA8E4FFF3DA5+mini.jpg",
  },
  {
    name: "Etiqueta BRONCO_4",
    id: 100569604,
    product: "Etiqueta Tejida",
    provider: "HACO",
    category: "Etiquetas",
    materials: [materials[0].key],
    techniques: [techniques[0].key, techniques[1].key, techniques[2].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "10",
    maxPrice: "49",
    price: "",
    timeDelivery: "40",
    book: "Portafolio IMX",
    brand: "BRONCO",
    img: "https://imx-imagenes.s3.amazonaws.com/216A4B0E-EEE1-4096-BC6C-98514B3E8226.JPG",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/216A4B0E-EEE1-4096-BC6C-98514B3E8226+mini.jpg",
  },
  {
    name: "Etiqueta BRONCO_5",
    id: 100569606,
    product: "Etiqueta Tejida",
    provider: "HACO",
    category: "Etiquetas",
    materials: [materials[0].key],
    techniques: [techniques[0].key, techniques[1].key, techniques[2].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "10",
    maxPrice: "49",
    price: "",
    timeDelivery: "40",
    book: "Portafolio IMX",
    brand: "BRONCO",
    img: "https://imx-imagenes.s3.amazonaws.com/4168BC11-E32E-4D9F-900C-5527F5A7B449.JPG",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/4168BC11-E32E-4D9F-900C-5527F5A7B449+mini.jpg",
  },
  {
    name: "Etiqueta BRONCO_6",
    id: 100569936,
    product: "Etiqueta Tejida",
    provider: "HACO",
    category: "Etiquetas",
    materials: [materials[0].key],
    techniques: [techniques[0].key, techniques[1].key, techniques[2].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "10",
    maxPrice: "49",
    price: "",
    timeDelivery: "40",
    book: "Portafolio IMX",
    brand: "BRONCO",
    img: "https://imx-imagenes.s3.amazonaws.com/D0D48DE4-57DE-4D43-A848-2684C1828384.JPG",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/D0D48DE4-57DE-4D43-A848-2684C1828384+mini.jpg",
  },
  {
    name: "Etiqueta Peruvian Connection",
    id: 100599693,
    product: "Etiqueta Tejida",
    provider: "HACO",
    category: "Etiquetas",
    materials: [materials[0].key],
    techniques: [techniques[0].key, techniques[1].key, techniques[2].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "10",
    maxPrice: "49",
    price: "",
    timeDelivery: "40",
    book: "Portafolio IMX",
    brand: "Peruvian Connection",
    img: "https://imx-imagenes.s3.amazonaws.com/AF21AC57-1412-4F8B-8892-D20495E424DC.JPG",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/AF21AC57-1412-4F8B-8892-D20495E424DC+mini.jpg",
  },
  {
    name: "Etiqueta Peruvian Connection",
    id: 100601776,
    product: "Etiqueta Tejida",
    provider: "HACO",
    category: "Etiquetas",
    materials: [materials[0].key],
    techniques: [techniques[0].key, techniques[1].key, techniques[2].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "10",
    maxPrice: "49",
    price: "",
    timeDelivery: "40",
    book: "Portafolio IMX",
    brand: "GLENDA BAILEY & PC",
    img: "https://imx-imagenes.s3.amazonaws.com/0100602320.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0100602320.jpg",
  },
  {
    name: "Etiqueta little PARNI alternativa",
    id: 100604107,
    product: "Etiqueta Tejida",
    provider: "HACO",
    category: "Etiquetas",
    materials: [materials[0].key],
    techniques: [techniques[0].key, techniques[1].key, techniques[2].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "10",
    maxPrice: "49",
    price: "",
    timeDelivery: "40",
    book: "Portafolio IMX",
    brand: "Parni Design",
    img: "https://imx-imagenes.s3.amazonaws.com/168EF863-DE75-469B-8418-E9C9C316AFA1.JPG",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/168EF863-DE75-469B-8418-E9C9C316AFA1+mini.jpg",
  },
  {
    name: "Etiqueta PARNI alternativa",
    id: 100604116,
    product: "Etiqueta Tejida",
    provider: "HACO",
    category: "Etiquetas",
    materials: [materials[0].key],
    techniques: [techniques[0].key, techniques[1].key, techniques[2].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "10",
    maxPrice: "49",
    price: "",
    timeDelivery: "40",
    book: "Portafolio IMX",
    brand: "Parni Design",
    img: "https://imx-imagenes.s3.amazonaws.com/93305F78-4997-414F-A942-0670A9A7BB45.JPG",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/93305F78-4997-414F-A942-0670A9A7BB45+mini.jpg",
  },
  {
    name: "Etiqueta Mashmelo",
    id: 100616275,
    product: "Etiqueta Tejida",
    provider: "HACO",
    category: "Etiquetas",
    materials: [materials[0].key, materials[1].key],
    techniques: [techniques[0].key, techniques[1].key, techniques[2].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "10",
    maxPrice: "49",
    price: "",
    timeDelivery: "40",
    book: "Portafolio IMX",
    brand: "Mashmelo",
    img: "https://imx-imagenes.s3.amazonaws.com/0100616275.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0100616275.jpg",
  },
  {
    name: "Etiqueta MARA intimates Algodón",
    id: 100618230,
    product: "Etiqueta Tejida",
    provider: "HACO",
    category: "Etiquetas",
    materials: [materials[3].key],
    techniques: [techniques[0].key, techniques[1].key, techniques[7].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "10",
    maxPrice: "49",
    price: "",
    timeDelivery: "40",
    book: "Portafolio IMX",
    brand: "MARA intimates",
    img: "https://imx-imagenes.s3.amazonaws.com/4D910025-4A28-4FFD-9416-24647B4733B6.JPG",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/4D910025-4A28-4FFD-9416-24647B4733B6+mini.jpg",
  },
  {
    name: "Etiqueta GINEBRA 3 Gatos",
    id: 100616275,
    product: "Etiqueta Tejida",
    provider: "HACO",
    category: "Etiquetas",
    materials: [materials[0].key, materials[1].key, materials[7].key],
    techniques: [techniques[0].key, techniques[1].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "10",
    maxPrice: "49",
    price: "",
    timeDelivery: "40",
    book: "Portafolio IMX",
    brand: "Mashmelo",
    img: "https://imx-imagenes.s3.amazonaws.com/GINEBRA+-+3+Gatos.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/GINEBRA+-+3+Gatos.jpg",
  },

  {
    name: "Juego de Broches",
    id: 800524655,
    product: "Broches",
    provider: "HACO",
    category: "Broches y Metales",
    materials: [materials[4].key],
    techniques: [techniques[18].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: true,
    minPrice: "10",
    maxPrice: "50",
    price: "",
    timeDelivery: "60",
    book: "Portafolio IMX",
    brand: "Generico",
    img: "https://imx-imagenes.s3.amazonaws.com/0800524655.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0800524655.jpg",
  },
  {
    name: "Cinta Satinada con Puntera Metalica",
    id: 200543252,
    product: "Cinta Tejida con Puntera Metalica",
    provider: "HACO",
    category: "Cintas",
    materials: [materials[0].key, materials[4].key],
    techniques: [techniques[0].key, techniques[1].key, techniques[8].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "500",
    stock: false,
    minPrice: "500",
    maxPrice: "999",
    price: "",
    timeDelivery: "60",
    book: "Portafolio IMX",
    brand: "Generico",
    img: "https://imx-imagenes.s3.amazonaws.com/0200543252-1.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0200543252-1.jpg",
  },
  {
    name: "Cinta MARA 3 Gatos",
    id: 100615197,
    product: "Cinta Tejida",
    provider: "HACO",
    category: "Cintas",
    materials: [materials[0].key, materials[1].key, materials[7].key, materials[8].key],
    techniques: [techniques[0].key, techniques[1].key, techniques[9].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "500",
    stock: false,
    minPrice: "50",
    maxPrice: "99",
    price: "",
    timeDelivery: "40",
    book: "Portafolio IMX",
    brand: "MARA intimates",
    img: "https://imx-imagenes.s3.amazonaws.com/Cinta+3+Gatos++-+MARA.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/Cinta+3+Gatos++-+MARA.jpg",
  },
  {
    name: "Cordon Redondo Tricolor",
    id: 200558902,
    product: "Cordon Redondo",
    provider: "HACO",
    category: "Cordones",
    materials: [materials[0].key],
    techniques: [techniques[1].key, techniques[9].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "500",
    stock: false,
    minPrice: "100",
    maxPrice: "499",
    price: "",
    timeDelivery: "40",
    book: "Portafolio IMX",
    brand: "Generico",
    img: "https://imx-imagenes.s3.amazonaws.com/0200558902.png",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0200558902.png",
  },
  {
    name: "Cordon Redondo Trenzado con Puntera de Goma Bicolor",
    id: 200565461,
    product: "Cordon Redondo Trenzado",
    provider: "HACO",
    category: "Cordones",
    materials: [materials[3].key, materials[5].key, materials[6].key],
    techniques: [techniques[1].key, techniques[8].key, techniques[10].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "500",
    stock: false,
    minPrice: "100",
    maxPrice: "1999",
    price: "",
    timeDelivery: "60",
    book: "Portafolio IMX",
    brand: "Generico",
    img: "https://imx-imagenes.s3.amazonaws.com/0200565461.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0200565461.jpg",
  },
  {
    name: "Cordon Plano con Puntera de Goma",
    id: 200565654,
    product: "Cordon Plano",
    provider: "HACO",
    category: "Cordones",
    materials: [materials[3].key, materials[5].key, materials[6].key],
    techniques: [techniques[1].key, techniques[8].key, techniques[10].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "500",
    stock: false,
    minPrice: "100",
    maxPrice: "1999",
    price: "",
    timeDelivery: "60",
    book: "Portafolio IMX",
    brand: "Generico",
    img: "https://imx-imagenes.s3.amazonaws.com/0200565654.png",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0200565654.png",
  },
  {
    name: "Cordon Redondo Jaspeado con Puntera de Goma Rustica",
    id: 200567635,
    product: "Cordon Redondo Jaspeado",
    provider: "HACO",
    category: "Cordones",
    materials: [materials[0].key, materials[6].key],
    techniques: [techniques[1].key, techniques[10].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "500",
    stock: false,
    minPrice: "100",
    maxPrice: "1999",
    price: "",
    timeDelivery: "60",
    book: "Portafolio IMX",
    brand: "Generico",
    img: "https://imx-imagenes.s3.amazonaws.com/0200567635.png",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0200567635.png",
  },
  {
    name: "Cordon Redondo con Puntera de Goma Bicolor",
    id: 200618226,
    product: "Cordon Redondo",
    provider: "HACO",
    category: "Cordones",
    materials: [materials[3].key, materials[5].key, materials[6].key],
    techniques: [techniques[1].key, techniques[8].key, techniques[10].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "500",
    stock: false,
    minPrice: "100",
    maxPrice: "1999",
    price: "",
    timeDelivery: "60",
    book: "Portafolio IMX",
    brand: "Generico",
    img: "https://imx-imagenes.s3.amazonaws.com/0200618226.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0200618226.jpg",
  },
  {
    name: "Cordon Elastico Redondo Negro",
    id: 202237164 - 5,
    product: "Cordon Elastico Redondo",
    provider: "HACO",
    category: "Cordones",
    materials: [materials[0].key, materials[17].key],
    techniques: [techniques[1].key, techniques[9].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "500",
    stock: false,
    minPrice: "50",
    maxPrice: "99",
    price: "",
    timeDelivery: "40",
    book: "Portafolio IMX",
    brand: "Generico",
    img: "https://imx-imagenes.s3.amazonaws.com/0202237164-5.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0202237164-5.jpg",
  },
  {
    name: "Cordon Elastico Redondo Pink",
    id: 202237164 - 69,
    product: "Cordon Elastico Redondo",
    provider: "HACO",
    category: "Cordones",
    materials: [materials[0].key, materials[17].key],
    techniques: [techniques[1].key, techniques[9].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "500",
    stock: false,
    minPrice: "50",
    maxPrice: "99",
    price: "",
    timeDelivery: "40",
    book: "Portafolio IMX",
    brand: "Generico",
    img: "https://imx-imagenes.s3.amazonaws.com/0202237164-69.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0202237164-69.jpg",
  },
  {
    name: "Cordon Elastico Redondo Verde",
    id: 202237164 - 70,
    product: "Cordon Elastico Redondo",
    provider: "HACO",
    category: "Cordones",
    materials: [materials[0].key, materials[17].key],
    techniques: [techniques[1].key, techniques[9].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "500",
    stock: false,
    minPrice: "50",
    maxPrice: "99",
    price: "",
    timeDelivery: "40",
    book: "Portafolio IMX",
    brand: "Generico",
    img: "https://imx-imagenes.s3.amazonaws.com/0202237164-70.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0202237164-70.jpg",
  },
  {
    name: "Cuerina Byrsa",
    id: 600588667,
    product: "Cuerina",
    provider: "HACO",
    category: "Cueros y Badanas",
    materials: [materials[2].key],
    techniques: [techniques[13].key, techniques[14].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "100",
    maxPrice: "499",
    price: "",
    timeDelivery: "60",
    book: "Portafolio IMX",
    brand: "Byrsa",
    img: "https://imx-imagenes.s3.amazonaws.com/0600588667.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0600588667.jpg",
  },
  {
    name: "Etiqueta Pantalon BRONCO_1",
    id: 600602095,
    product: "Badana",
    provider: "HACO",
    category: "Cueros y Badanas",
    materials: [materials[11].key],
    techniques: [techniques[1].key, techniques[12].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "100",
    maxPrice: "499",
    price: "",
    timeDelivery: "60",
    book: "Portafolio IMX",
    brand: "BRONCO",
    img: "https://imx-imagenes.s3.amazonaws.com/48619073-76E7-42BD-851A-B3BE4E7D089F.JPG",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/48619073-76E7-42BD-851A-B3BE4E7D089F+mini.jpg",
  },
  {
    name: "Etiqueta Pantalon BRONCO_2",
    id: 600602371,
    product: "Badana",
    provider: "HACO",
    category: "Cueros y Badanas",
    materials: [materials[11].key],
    techniques: [techniques[1].key, techniques[12].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "100",
    maxPrice: "499",
    price: "",
    timeDelivery: "60",
    book: "Portafolio IMX",
    brand: "BRONCO",
    img: "https://imx-imagenes.s3.amazonaws.com/524596F5-C61E-4650-B327-CF4D08F000FE.JPG",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/524596F5-C61E-4650-B327-CF4D08F000FE+mini.jpg",
  },
  {
    name: "Etiqueta Pantalon BRONCO_3",
    id: 600602377,
    product: "Badana",
    provider: "HACO",
    category: "Cueros y Badanas",
    materials: [materials[11].key],
    techniques: [techniques[1].key, techniques[12].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "100",
    maxPrice: "499",
    price: "",
    timeDelivery: "60",
    book: "Portafolio IMX",
    brand: "BRONCO",
    img: "https://imx-imagenes.s3.amazonaws.com/788FDC28-419A-4935-B913-BB3BF34EB7BD.JPG",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/788FDC28-419A-4935-B913-BB3BF34EB7BD+mini.jpg",
  },
  {
    name: "Etiqueta Pantalon BRONCO_4",
    id: 600602380,
    product: "Badana",
    provider: "HACO",
    category: "Cueros y Badanas",
    materials: [materials[11].key],
    techniques: [techniques[1].key, techniques[12].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "100",
    maxPrice: "499",
    price: "",
    timeDelivery: "60",
    book: "Portafolio IMX",
    brand: "BRONCO",
    img: "https://imx-imagenes.s3.amazonaws.com/578C43B4-F564-4210-9B52-461472B6A5A1.JPG",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/578C43B4-F564-4210-9B52-461472B6A5A1+mini.jpg",
  },
  {
    name: "Etiqueta Pantalon BRONCO_5",
    id: 600602382,
    product: "Badana",
    provider: "HACO",
    category: "Cueros y Badanas",
    materials: [materials[11].key],
    techniques: [techniques[1].key, techniques[12].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "100",
    maxPrice: "499",
    price: "",
    timeDelivery: "60",
    book: "Portafolio IMX",
    brand: "BRONCO",
    img: "https://imx-imagenes.s3.amazonaws.com/2A119F50-1067-477F-A78A-9484B6DB05F0.JPG",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/2A119F50-1067-477F-A78A-9484B6DB05F0+mini.jpg",
  },
  {
    name: "Etiqueta Pantalon BRONCO_6",
    id: 600602371,
    product: "Badana",
    provider: "HACO",
    category: "Cueros y Badanas",
    materials: [materials[11].key],
    techniques: [techniques[1].key, techniques[12].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "100",
    maxPrice: "499",
    price: "",
    timeDelivery: "60",
    book: "Portafolio IMX",
    brand: "BRONCO",
    img: "https://imx-imagenes.s3.amazonaws.com/B0219682-78EF-4880-9A24-C5935E5735BE.JPG",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/B0219682-78EF-4880-9A24-C5935E5735BE+mini.jpg",
  },
  {
    name: "Badana RAPSODIA Oscura",
    id: 600604394,
    product: "Badana",
    provider: "HACO",
    category: "Cueros y Badanas",
    materials: [materials[2].key],
    techniques: [techniques[4].key, techniques[14].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "100",
    maxPrice: "499",
    price: "",
    timeDelivery: "60",
    book: "Portafolio IMX",
    brand: "RAPSODIA",
    img: "https://imx-imagenes.s3.amazonaws.com/0600604394.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0600604394.jpg",
  },
  {
    name: "Badana RAPSODIA Clara",
    id: 600610644,
    product: "Badana",
    provider: "HACO",
    category: "Cueros y Badanas",
    materials: [materials[2].key],
    techniques: [techniques[4].key, techniques[14].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "100",
    maxPrice: "499",
    price: "",
    timeDelivery: "60",
    book: "Portafolio IMX",
    brand: "RAPSODIA",
    img: "https://imx-imagenes.s3.amazonaws.com/0600610644.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0600610644.jpg",
  },
  {
    name: "Cuerina Chester & Peck",
    id: 600615591,
    product: "Badana",
    provider: "HACO",
    category: "Cueros y Badanas",
    materials: [materials[2].key],
    techniques: [techniques[4].key, techniques[13].key, techniques[16].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "100",
    maxPrice: "499",
    price: "",
    timeDelivery: "60",
    book: "Portafolio IMX",
    brand: "Chester & Peck",
    img: "https://imx-imagenes.s3.amazonaws.com/0600615591.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0600615591.jpg",
  },
  {
    name: "Badana Kids Made Here",
    id: 600618221,
    product: "Badana",
    provider: "HACO",
    category: "Cueros y Badanas",
    materials: [materials[11].key],
    techniques: [techniques[1].key, techniques[12].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "10",
    maxPrice: "50",
    price: "",
    timeDelivery: "40",
    book: "Portafolio IMX",
    brand: "KMH",
    img: "https://imx-imagenes.s3.amazonaws.com/18071FE6-C3A1-44BD-A3B7-2122F31ED41E.JPG",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/18071FE6-C3A1-44BD-A3B7-2122F31ED41E+mini.jpg",
  },

  {
    name: "Etiqueta Peruvian Connection",
    id: 300599696,
    product: "Etiqueta Estampada",
    provider: "HACO",
    category: "Etiquetas",
    materials: [materials[0].key],
    techniques: [techniques[0].key, techniques[1].key, techniques[2].key, techniques[6].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "10",
    maxPrice: "49",
    price: "",
    timeDelivery: "40",
    book: "Portafolio IMX",
    brand: "Peruvian Connection",
    img: "https://imx-imagenes.s3.amazonaws.com/74E96A65-037D-415E-A70F-40D5C764F386.JPG",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/74E96A65-037D-415E-A70F-40D5C764F386+mini.jpg",
  },
  {
    name: "Etiqueta GINEBRA 3 Gatos",
    id: 300608988,
    product: "Etiqueta Estampada",
    provider: "HACO",
    category: "Etiquetas",
    materials: [materials[0].key, materials[7].key, materials[9].key],
    techniques: [techniques[0].key, techniques[1].key, techniques[6].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "50",
    maxPrice: "99",
    price: "",
    timeDelivery: "40",
    book: "Portafolio IMX",
    brand: "GINEBRA",
    img: "https://imx-imagenes.s3.amazonaws.com/0300608988.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0300608988.jpg",
  },
  {
    name: "Etiquetas de Cuidado Lilla|P",
    id: 300612613,
    product: "Etiqueta Estampada",
    provider: "HACO",
    category: "Etiquetas",
    materials: [materials[0].key],
    techniques: [techniques[0].key, techniques[1].key, techniques[2].key, techniques[6].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "10",
    maxPrice: "49",
    price: "",
    timeDelivery: "40",
    book: "Portafolio IMX",
    brand: "Lilla|P",
    img: "https://imx-imagenes.s3.amazonaws.com/0300612613.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0300612613.jpg",
  },
  {
    name: "Etiqueta MARA intimates Algodón",
    id: 300615206,
    product: "Etiqueta Estampada",
    provider: "HACO",
    category: "Etiquetas",
    materials: [materials[3].key],
    techniques: [techniques[0].key, techniques[1].key, techniques[2].key, techniques[6].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "10",
    maxPrice: "49",
    price: "",
    timeDelivery: "40",
    book: "Portafolio IMX",
    brand: "MARA intimates",
    img: "https://imx-imagenes.s3.amazonaws.com/0300615206.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0300615206.jpg",
  },
  {
    name: "Etiqueta MARA intimates Algodón",
    id: 300618232,
    product: "Etiqueta Estampada",
    provider: "HACO",
    category: "Etiquetas",
    materials: [materials[3].key],
    techniques: [techniques[0].key, techniques[1].key, techniques[2].key, techniques[7].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "10",
    maxPrice: "49",
    price: "",
    timeDelivery: "40",
    book: "Portafolio IMX",
    brand: "MARA intimates",
    img: "https://imx-imagenes.s3.amazonaws.com/0300618232.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0300618232.jpg",
  },
  {
    name: "Etiqueta de Talla Kids Made Here",
    id: 600618219,
    product: "Etiqueta Estampada",
    provider: "HACO",
    category: "Etiquetas",
    materials: [materials[16].key],
    techniques: [techniques[1].key, techniques[12].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "10",
    maxPrice: "50",
    price: "",
    timeDelivery: "60",
    book: "Portafolio IMX",
    brand: "KMH",
    img: "https://imx-imagenes.s3.amazonaws.com/0600618219.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0600618219.jpg",
  },
  {
    name: "Sigilo de Seguridad Especial Blanco",
    id: 800554667,
    product: "Sigilo de Seguridad",
    provider: "HACO",
    category: "Sigilos de Seguridad",
    materials: [materials[0].key, materials[15].key],
    techniques: [techniques[17].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: true,
    minPrice: "10",
    maxPrice: "50",
    price: "",
    timeDelivery: "30",
    book: "Portafolio IMX",
    brand: "Generico",
    img: "https://imx-imagenes.s3.amazonaws.com/0800554667.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0800554667.jpg",
  },
  {
    name: "Sigilo de Seguridad HACO Color Negro",
    id: "0900522243 - 2",
    product: "Sigilo de Seguridad",
    provider: "HACO",
    category: "Sigilos de Seguridad",
    materials: [materials[0].key, materials[15].key],
    techniques: [techniques[17].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: true,
    minPrice: "10",
    maxPrice: "50",
    price: "",
    timeDelivery: "30",
    book: "Portafolio IMX",
    brand: "Generico",
    img: "https://imx-imagenes.s3.amazonaws.com/0900522243-2.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0900522243-2.jpg",
  },
  {
    name: "Sigilo de Seguridad HACO Color Blanco",
    id: "0900522243 - 3",
    product: "Sigilo de Seguridad",
    provider: "HACO",
    category: "Sigilos de Seguridad",
    materials: [materials[0].key, materials[15].key],
    techniques: [techniques[17].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: true,
    minPrice: "10",
    maxPrice: "50",
    price: "",
    timeDelivery: "30",
    book: "Portafolio IMX",
    brand: "Generico",
    img: "https://imx-imagenes.s3.amazonaws.com/0900522243-3.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0900522243-3.jpg",
  },
  {
    name: "Sigilo de Seguridad HACO Color Crema",
    id: "0900522243 - 4",
    product: "Sigilo de Seguridad",
    provider: "HACO",
    category: "Sigilos de Seguridad",
    materials: [materials[0].key, materials[15].key],
    techniques: [techniques[17].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: true,
    minPrice: "10",
    maxPrice: "50",
    price: "",
    timeDelivery: "30",
    book: "Portafolio IMX",
    brand: "Generico",
    img: "https://imx-imagenes.s3.amazonaws.com/0900522243-4.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0900522243-4.jpg",
  },
  {
    name: "Sigilo de Seguridad HACO Color Rojo",
    id: "0900522243 - 5",
    product: "Sigilo de Seguridad",
    provider: "HACO",
    category: "Sigilos de Seguridad",
    materials: [materials[0].key, materials[15].key],
    techniques: [techniques[17].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: true,
    minPrice: "10",
    maxPrice: "50",
    price: "",
    timeDelivery: "30",
    book: "Portafolio IMX",
    brand: "Generico",
    img: "https://imx-imagenes.s3.amazonaws.com/0900522243-5.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0900522243-5.jpg",
  },
  {
    name: "Sigilo de Seguridad HACO Color Azul",
    id: "0900522243 - 6",
    product: "Sigilo de Seguridad",
    provider: "HACO",
    category: "Sigilos de Seguridad",
    materials: [materials[0].key, materials[15].key],
    techniques: [techniques[17].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: true,
    minPrice: "10",
    maxPrice: "50",
    price: "",
    timeDelivery: "30",
    book: "Portafolio IMX",
    brand: "Generico",
    img: "https://imx-imagenes.s3.amazonaws.com/0900522243-6.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0900522243-6.jpg",
  },
  {
    name: "Escudo de Goma PCDA",
    id: 600604406,
    product: "Etiqueta de Goma",
    provider: "HACO",
    category: "Transfer y Adhesivos",
    materials: [materials[2].key, materials[6].key],
    techniques: [techniques[3].key, techniques[17].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "100",
    maxPrice: "499",
    price: "",
    timeDelivery: "60",
    book: "Portafolio IMX",
    brand: "PCDA",
    img: "https://imx-imagenes.s3.amazonaws.com/0600604406.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0600604406.jpg",
  },
  {
    name: "Parche de Goma Redondo 2 colores NORTON",
    id: 600617189,
    product: "Etiqueta de Goma",
    provider: "HACO",
    category: "Transfer y Adhesivos",
    materials: [materials[2].key],
    techniques: [techniques[3].key, techniques[17].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "500",
    maxPrice: "999",
    price: "",
    timeDelivery: "60",
    book: "Portafolio IMX",
    brand: "NORTON",
    img: "https://imx-imagenes.s3.amazonaws.com/0600617189.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0600617189.jpg",
  },
  {
    name: "Parche de Goma Redondo 3 colores NORTON",
    id: 600617192,
    product: "Etiqueta de Goma",
    provider: "HACO",
    category: "Transfer y Adhesivos",
    materials: [materials[2].key],
    techniques: [techniques[3].key, techniques[17].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "500",
    maxPrice: "999",
    price: "",
    timeDelivery: "60",
    book: "Portafolio IMX",
    brand: "NORTON",
    img: "https://imx-imagenes.s3.amazonaws.com/0600617192.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0600617192.jpg",
  },
  {
    name: "Parche de Goma Ovalado 2 colores NORTON_1",
    id: 600617194 - 1,
    product: "Etiqueta de Goma",
    provider: "HACO",
    category: "Transfer y Adhesivos",
    materials: [materials[2].key],
    techniques: [techniques[3].key, techniques[17].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "500",
    maxPrice: "999",
    price: "",
    timeDelivery: "60",
    book: "Portafolio IMX",
    brand: "NORTON",
    img: "https://imx-imagenes.s3.amazonaws.com/0600617194-1.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0600617194-1.jpg",
  },
  {
    name: "Parche de Goma Ovalado 2 colores NORTON_2",
    id: 600617194 - 2,
    product: "Etiqueta de Goma",
    provider: "HACO",
    category: "Transfer y Adhesivos",
    materials: [materials[2].key],
    techniques: [techniques[3].key, techniques[17].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "500",
    maxPrice: "999",
    price: "",
    timeDelivery: "60",
    book: "Portafolio IMX",
    brand: "NORTON",
    img: "https://imx-imagenes.s3.amazonaws.com/0600617194-2.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0600617194-2.jpg",
  },
  {
    name: "Parche de Goma Ovalado 2 colores NORTON_3",
    id: 600617194 - 3,
    product: "Etiqueta de Goma",
    provider: "HACO",
    category: "Transfer y Adhesivos",
    materials: [materials[2].key],
    techniques: [techniques[3].key, techniques[17].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "500",
    maxPrice: "999",
    price: "",
    timeDelivery: "60",
    book: "Portafolio IMX",
    brand: "NORTON",
    img: "https://imx-imagenes.s3.amazonaws.com/0600617194-3.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0600617194-3.jpg",
  },
  {
    name: "Parche de Goma Cuadrado 2 colores NORTON_1",
    id: 600617196 - 1,
    product: "Etiqueta de Goma",
    provider: "HACO",
    category: "Transfer y Adhesivos",
    materials: [materials[2].key],
    techniques: [techniques[3].key, techniques[17].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "500",
    maxPrice: "999",
    price: "",
    timeDelivery: "60",
    book: "Portafolio IMX",
    brand: "NORTON",
    img: "https://imx-imagenes.s3.amazonaws.com/0600617196-1.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0600617196-1.jpg",
  },
  {
    name: "Parche de Goma Cuadrado 2 colores NORTON_2",
    id: 600617196 - 2,
    product: "Etiqueta de Goma",
    provider: "HACO",
    category: "Transfer y Adhesivos",
    materials: [materials[2].key],
    techniques: [techniques[3].key, techniques[17].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "500",
    maxPrice: "999",
    price: "",
    timeDelivery: "60",
    book: "Portafolio IMX",
    brand: "NORTON",
    img: "https://imx-imagenes.s3.amazonaws.com/0600617196-2.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0600617196-2.jpg",
  },
  {
    name: "Parche de Goma Transparente Rectangular 2 Colores NORTON",
    id: 600618040,
    product: "Etiqueta de Goma",
    provider: "HACO",
    category: "Transfer y Adhesivos",
    materials: [materials[2].key],
    techniques: [techniques[3].key, techniques[17].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "500",
    maxPrice: "999",
    price: "",
    timeDelivery: "60",
    book: "Portafolio IMX",
    brand: "NORTON",
    img: "https://imx-imagenes.s3.amazonaws.com/0600618040.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0600618040.jpg",
  },
  {
    name: "Parche de Goma Transparente Rectangular 2 Colores NORTON_UK",
    id: 600618044,
    product: "Etiqueta de Goma",
    provider: "HACO",
    category: "Transfer y Adhesivos",
    materials: [materials[2].key],
    techniques: [techniques[3].key, techniques[17].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "500",
    maxPrice: "999",
    price: "",
    timeDelivery: "60",
    book: "Portafolio IMX",
    brand: "NORTON",
    img: "https://imx-imagenes.s3.amazonaws.com/0600618044.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0600618044.jpg",
  },

  {
    name: "Etiqueta de Cuidado MARA intimates",
    id: 100489872,
    product: "Etiqueta Tejida en Saten",
    provider: "HACO",
    category: "Etiquetas",
    materials: [materials[0].key],
    techniques: [techniques[0].key, techniques[1].key, techniques[2].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "10",
    maxPrice: "49",
    price: "",
    timeDelivery: "40",
    book: "Portafolio IMX",
    brand: "MARA intimates",
    img: "https://imx-imagenes.s3.amazonaws.com/0100489872.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0100489872.jpg",
  },
  {
    name: "Etiqueta MARA Relieve Grande",
    id: 100616278,
    product: "Etiqueta Tejida en Saten",
    provider: "HACO",
    category: "Etiquetas",
    materials: [materials[0].key],
    techniques: [techniques[0].key, techniques[1].key, techniques[2].key, techniques[5].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "5000",
    stock: false,
    minPrice: "50",
    maxPrice: "99",
    price: "",
    timeDelivery: "40",
    book: "Portafolio IMX",
    brand: "MARA intimates",
    img: "https://imx-imagenes.s3.amazonaws.com/0100616278.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0100616278.jpg",
  },
  {
    name: "Etiqueta MARA Relieve Chica",
    id: 100616471,
    product: "Etiqueta Tejida en Saten",
    provider: "HACO",
    category: "Etiquetas",
    materials: [materials[0].key],
    techniques: [techniques[0].key, techniques[1].key, techniques[2].key, techniques[5].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "5000",
    stock: false,
    minPrice: "50",
    maxPrice: "99",
    price: "",
    timeDelivery: "40",
    book: "Portafolio IMX",
    brand: "MARA intimates",
    img: "https://imx-imagenes.s3.amazonaws.com/0100616471.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0100616471.jpg",
  },
  {
    name: "Hangtag Principal Lilla|P",
    id: 400558791,
    product: "Hangtag",
    provider: "HACO",
    category: "Hangtags y Sigilos",
    materials: [materials[10].key],
    techniques: [techniques[12].key, techniques[13].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "5000",
    stock: true,
    minPrice: "50",
    maxPrice: "99",
    price: "",
    timeDelivery: "60",
    book: "Portafolio IMX",
    brand: "Lilla|P",
    img: "https://imx-imagenes.s3.amazonaws.com/0400558791.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0400558791.jpg",
  },
  {
    name: "Hangtag Disclaimer Lilla|P",
    id: 400558793,
    product: "Hangtag",
    provider: "HACO",
    category: "Hangtags y Sigilos",
    materials: [materials[10].key],
    techniques: [techniques[12].key, techniques[13].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "5000",
    stock: true,
    minPrice: "50",
    maxPrice: "99",
    price: "",
    timeDelivery: "60",
    book: "Portafolio IMX",
    brand: "Lilla|P",
    img: "https://imx-imagenes.s3.amazonaws.com/0400558793.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0400558793.jpg",
  },
  {
    name: "Adhesivo con Resina Fortunata & Benito",
    id: 600602324,
    product: "Etiqueta Adhesiva con Resina",
    provider: "HACO",
    category: "Transfer y Adhesivos",
    materials: [materials[2].key, materials[12].key, materials[13].key],
    techniques: [techniques[4].key, techniques[12].key, techniques[15].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "100",
    maxPrice: "499",
    price: "",
    timeDelivery: "60",
    book: "Portafolio IMX",
    brand: "Fortunata & Benito",
    img: "https://imx-imagenes.s3.amazonaws.com/0600602324.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0600602324.jpg",
  },
  {
    name: "Etiqueta Reflectiva GINEBRA_1",
    id: 600604404,
    product: "Transfer Reflectivo",
    provider: "HACO",
    category: "Transfer y Adhesivos",
    materials: [materials[2].key, materials[14].key],
    techniques: [techniques[1].key, techniques[3].key, techniques[12].key, techniques[17].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "100",
    maxPrice: "499",
    price: "",
    timeDelivery: "60",
    book: "Portafolio IMX",
    brand: "GINEBRA",
    img: "https://imx-imagenes.s3.amazonaws.com/0600604404.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0600604404.jpg",
  },
  {
    name: "Etiqueta Reflectiva GINEBRA_2",
    id: 600604412,
    product: "Transfer Reflectivo",
    provider: "HACO",
    category: "Transfer y Adhesivos",
    materials: [materials[2].key, materials[14].key],
    techniques: [techniques[1].key, techniques[3].key, techniques[12].key, techniques[17].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "100",
    maxPrice: "499",
    price: "",
    timeDelivery: "60",
    book: "Portafolio IMX",
    brand: "GINEBRA",
    img: "https://imx-imagenes.s3.amazonaws.com/0600604412.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0600604412.jpg",
  },
  {
    name: "Parche Gummi Form NORTON_1",
    id: 600617037,
    product: "Escudo PVC",
    provider: "HACO",
    category: "Transfer y Adhesivos",
    materials: [materials[15].key],
    techniques: [techniques[3].key, techniques[17].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "500",
    maxPrice: "999",
    price: "",
    timeDelivery: "60",
    book: "Portafolio IMX",
    brand: "NORTON",
    img: "https://imx-imagenes.s3.amazonaws.com/0600617037.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0600617037.jpg",
  },
  {
    name: "Parche Gummi Form NORTON_2",
    id: 600617041,
    product: "Escudo PVC",
    provider: "HACO",
    category: "Transfer y Adhesivos",
    materials: [materials[15].key],
    techniques: [techniques[3].key, techniques[17].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: false,
    minPrice: "500",
    maxPrice: "999",
    price: "",
    timeDelivery: "60",
    book: "Portafolio IMX",
    brand: "NORTON",
    img: "https://imx-imagenes.s3.amazonaws.com/0600617041.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0600617041.jpg",
  },
  {
    name: "Parche GINEBRA",
    id: 100604121,
    product: "Escudo 100% Tejido Termoadhesivo",
    provider: "HACO",
    category: "Etiquetas",
    materials: [materials[0].key, materials[1].key],
    techniques: [techniques[0].key, techniques[3].key, techniques[4].key],
    dimensions: "",
    sustainability: false,
    unit: "Millar",
    moq: "1000",
    stock: true,
    minPrice: "100",
    maxPrice: "499",
    price: "",
    timeDelivery: "40",
    book: "Portafolio IMX",
    brand: "GINEBRA",
    img: "https://imx-imagenes.s3.amazonaws.com/0100604121.jpg",
    imgMini: "https://imx-imagenes.s3.amazonaws.com/0100604121.jpg",
  },


];
